module.exports = __webpack_public_path__ + "static/media/tabletennis-icon.aea8768d.svg";